import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { NODE_SUPERTYPE, NODE_TYPE } from "../../common/linqset-model";
import { ModelInsights } from "../../common/organisation";

@Component({
    selector: 'app-node-numbers',
    templateUrl: './node-numbers.html',
    styleUrls: ['./node-numbers.css'],
    standalone: false
})
export class NodeNumbersComponent implements OnInit, OnChanges {
    @Input() insights:ModelInsights
    @Input() trigger:any
    @Input() canSelect:boolean
    @Input() mostHours:any[]

    data:{name:string, type:NODE_TYPE, number:number}[]
    selected:NODE_TYPE|undefined

    @Output() selectTypeEvent = new EventEmitter<NODE_TYPE>()

    constructor() {}
    
    ngOnInit(): void {
        this.setupData()
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setupData()
    }

    setupData() {
        this.data = []
        if (!this.insights) return

        this.data.push({name:'Action', type:NODE_TYPE.ACTION, number:this.insights.superTypes[NODE_SUPERTYPE.ACTION].number})
        this.data.push({name:'Info', type:NODE_TYPE.INFORMATION, number:this.insights.superTypes[NODE_SUPERTYPE.INFORMATION].number})
        this.data.push({name:'Role', type:NODE_TYPE.ROLE, number:this.insights.superTypes[NODE_SUPERTYPE.ROLE].number})
        this.data.push({name:'System', type:NODE_TYPE.SYSTEM, number:this.insights.superTypes[NODE_SUPERTYPE.SYSTEM].number})
        this.data.push({name:'Outcome', type:NODE_TYPE.OUTCOMES, number:this.insights.superTypes[NODE_SUPERTYPE.OUTCOMES].number})
        if (this.insights.superTypes[NODE_SUPERTYPE.PEOPLE]?.number > 0) {
            this.data.push({name:'People', type:NODE_TYPE.PERSON, number:this.insights.superTypes[NODE_SUPERTYPE.PEOPLE].number})
        }
        if (this.insights.superTypes[NODE_SUPERTYPE.INFRASTRUCTURE]?.number > 0) {
            this.data.push({name:'Infrastructure', type:NODE_TYPE.INFRASTRUCTURE, number:this.insights.superTypes[NODE_SUPERTYPE.INFRASTRUCTURE].number})
        }
    }

    selectType(type:NODE_TYPE) {
        if (this.canSelect) {
            this.selected = type
            this.selectTypeEvent.emit(type)
        }
    }
}